<template>
  <v-container>
    <NewPressNewForm v-if="$route.params.formName === 'newPressNewForm'" />
    <ModifyPressNewForm
      v-if="$route.params.formName === 'modifyPressNewForm'"
    />
  </v-container>
</template>

<script>
import axios from "axios";
import NewPressNewForm from "@/components/newsPress/forms/NewPressNewForm";
import ModifyPressNewForm from "@/components/newsPress/forms/ModifyPressNewForm";
export default {
  components: {
    ModifyPressNewForm,
    NewPressNewForm
  },
  name: "PressNewForms",

  data() {
    return {
      pressNew: ""
    };
  },
  methods: {
    setBreadcrumb() {
      let pressNew = {
        text: this.pressNew,
        exact: true,
        href: "/pressNews/" + this.$route.params.id,
        last: true
      };
      let form = {
        text: "section." + this.$route.params.formName,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.push(pressNew);
        }
        this.$route.meta.breadCrumb.push(form);
      } else {
        this.$route.meta.breadCrumb.pop();
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.pop();
          this.$route.meta.breadCrumb.push(pressNew);
        }
        this.$route.meta.breadCrumb.push(form);
      }
      this.$store.state.sectionTitle = "section." + this.$route.params.formName;
    },
    getPressNew() {
      if (
        this.$route.params.formName === "modifyPressNewForm" &&
        this.$route.meta.update
      ) {
        const path =
          this.$store.state.endpoint + "/user/news/" + this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.pressNew = response.data.title;
          })
          .finally(() => {
            this.setBreadcrumb();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.setBreadcrumb();
      }
    }
  },

  created() {
    this.getPressNew();
  },

  updated() {
    this.getPressNew();
  }
};
</script>

<style scoped></style>
